// extracted by mini-css-extract-plugin
module.exports = {"root":"home_root__WQikF","img":"home_img__28ISG","button":"home_button__1poLS"};